import { Badge } from "@/components/ui/badge"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card"

interface DominatedUnitsCardProps {
  diff?: number | null
  value: number
  totalUnits: number
}

export default function DominatedUnitsCard({ diff, value, totalUnits }: DominatedUnitsCardProps) {
  const safeValue = isNaN(value) ? 0 : value
  const diffValue = isNaN(diff ?? 0) ? 0 : (diff ?? 0)

  const formatDiff = () => {
    const percentage = diffValue * 100
    const formattedPercentage = Math.round(percentage)
    if (formattedPercentage === 0) return "0% sem.pasada"
    return `${percentage > 0 ? "+" : ""} ${formattedPercentage}% sem.pasada`
  }

  const variant = diffValue === 0 ? "warning" : diffValue > 0 ? "default" : "destructive"

  const valueText = `${safeValue}/${totalUnits}`

  return (
    <Card className="flex size-full min-h-[120px] min-w-[120px] flex-col border-none lg:min-h-[162px] lg:min-w-[200px]">
      <CardHeader>
        <CardTitle className="text-sm font-semibold text-foreground">Unidades dominadas</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-1 items-center gap-2">
        <span className="text-2xl">🏅</span>
        <h2 className="text-2xl font-bold text-foreground">{valueText}</h2>
      </CardContent>
      {diff !== null && diff !== undefined && (
        <CardFooter>
          <Badge variant={variant} className="w-fit">
            {formatDiff()}
          </Badge>
        </CardFooter>
      )}
    </Card>
  )
}
